/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {FC, useEffect, useState, useMemo, useCallback, useRef} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  getLaundryFrecuency,
  getLaundryFrecuencyReportPDF,
  getLaundryFrecuencyReportXLS,
  getLaundryFrecuencyReportCSV,
} from '../../../../services'
import {FormProvider, useForm} from 'react-hook-form'
import {Select} from '../../../../../../components/UI/Select'
import InputDate from '../../../../../../components/UI/Input/inputDate'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaLaundryFilter} from '../../../../../../util/validationLavanderia'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {
  LaundryFrecuencyModel,
  LaundryFrecuencySchemaModel,
  LaundryFrecuencySearchModel,
} from '../../../../features/laundryFrecuency/model/laundryFrecuency.model'
import {getFormatDate} from '../../../../../../util/functions'
import {donwloadFile} from '../../../../helpers/utilities'
import {useCamp, useClient, useSite, useCompany} from '../../../../../central/hooks'
import {SelectModel} from '../../../../model'
interface FormattedDate {
  fecha: string
  tiempo: string
  fechaMin: string
}

const downloadReportForType = {
  pdf: getLaundryFrecuencyReportPDF,
  xlsx: getLaundryFrecuencyReportXLS,
  csv: getLaundryFrecuencyReportCSV,
}

type TypeDownloadReport = keyof typeof downloadReportForType

const TableLaundryFrecuency: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const [formValue, setFormValue] = useState<any>(null)
  const [isOpenDownloadMenu, setIsOpenDownloadMenu] = useState<boolean>(false)
  const [searching, setIsSearching] = useState<boolean>(false)
  const [isDownload, setIsDownload] = useState<boolean>(false)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const refWrapperDownload = useRef<HTMLDivElement | null>(null)
  const {isAllowed} = useLavanderia()
  const methods = useForm<LaundryFrecuencySchemaModel>({
    resolver: yupResolver(schemaLaundryFilter),
  })

  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    reset,
  } = methods

  const {laundryPoint, getLaundryPointList, handleClearList} = useLaundryFilter()
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
      getLaundryPointList(response[0].value)
    }
    setCamps(response)
  }
  useEffect(() => {
    getCompanyList()
  }, [])
  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
  }

  const handleFilterLaundryPoint = (e: any) => {
    let value = e.value
    getLaundryPointList(value)
    setValue('campamentoId', value)
    setError('campamentoId', {})
  }

  const getLaundryList = useCallback(
    async (props: LaundryFrecuencySearchModel = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryFrecuency({...props})
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
      setIsSearching(false)
    },
    [setLoading, setData, pagination.currentPage],
  )

  const handleToggleOpenMenu = () => {
    setIsOpenDownloadMenu(!isOpenDownloadMenu)
  }

  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    setIsDownload(true)
    setIsOpenDownloadMenu(false)
    let data = {}
    if (formValue) {
      const {campamentoId, puntoId, fechaIni, fechaFin} = formValue
      data = {
        campamentoId,
        puntoId,
        fechaPeriodoInicio: fechaIni ? new Date(fechaIni) : '',
        fechaPeriodoFin: fechaFin ? new Date(fechaFin) : '',
      }
    }
    const response = await downloadReportForType[typeFormat](data)
    await donwloadFile(response.data, typeFormat)
    setIsDownload(false)
  }

  const columns: Column<LaundryFrecuencyModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Punto de Lavandería' />,
        accessor: 'puntoLavanderia',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de envío de ropa sucia' />,
        accessor: 'fechaEnvioRopaSucia',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaEnvioRopaSucia
            ? getFormatDate(props.data[props.row.index].fechaEnvioRopaSucia)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nº de bolsas totales entregadas' />
        ),
        accessor: 'nroBolsasEntregadas',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso Total (KG)' />,
        accessor: 'pesoTotal',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ropa de Usuario' />,
        accessor: 'ropaUsuario',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ropa Operación' />,
        accessor: 'ropaOperacion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Día 1 Cantidad' />,
        accessor: 'dia1Cantidad',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Día 2 Cantidad' />,
        accessor: 'dia2Cantidad',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Día 3 Entrega Final' />,
        accessor: 'dia3EntregaFinal',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Paquetes restantes (Incumplimiento)' />
        ),
        accessor: 'paquetesRestantes',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de recepción de ropa limpia' />
        ),
        accessor: 'fechaRecepcion',
        Cell: ({...props}) => {
          let dateProgram = props.data[props.row.index].fechaRecepcion
            ? getFormatDate(props.data[props.row.index].fechaRecepcion)
            : ''
          return <span>{dateProgram ? (dateProgram as FormattedDate).fecha : ''}</span>
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total de recepción' />,
        accessor: 'totalRecepcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Lavado (Días)' />,
        accessor: 'tiempoLavadoDias',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Status' />,
        accessor: 'status',
      },
    ],
    [],
  )

  const onSubmit = (dataForm: LaundryFrecuencySchemaModel) => {
    setIsSearching(true)
    const {campamentoId, puntoId, fechaIni, fechaFin} = dataForm
    setFormValue(dataForm)
    getLaundryList({
      pageNumber: 1,
      campamentoId,
      puntoId,
      fechaPeriodoInicio: fechaIni ? new Date(fechaIni) : '',
      fechaPeriodoFin: fechaFin ? new Date(fechaFin) : '',
    })
  }

  const handleResetForm = (): void => {
    reset()
    handleClearList()
    setFormValue(null)
    setIsSearching(false)
  }

  useEffect(() => {
    getLaundryList({pageNumber: pagination.currentPage})
  }, [pagination.currentPage])

  useEffect(() => {
    getCompanyList()
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (refWrapperDownload.current && !refWrapperDownload.current.contains(event.target)) {
        setIsOpenDownloadMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('BUSCAR_ENCABEZADO') && (
          <div className='p-6'>
            <FormProvider {...methods}>
              <form className='m-2' onSubmit={handleSubmit(onSubmit)}>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Compañía:</label>
                    <Select
                      control={control}
                      disabled={company.length === 0}
                      name='companiaId'
                      data={company}
                      errors={errors}
                      onChangeValue={handleFilterClient}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Cliente:</label>
                    <Select
                      control={control}
                      name='clienteId'
                      data={clients}
                      disabled={clients.length === 0}
                      errors={errors}
                      onChangeValue={handleFilterSite}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Site:</label>
                    <Select
                      control={control}
                      name='siteId'
                      disabled={sites.length === 0}
                      data={sites}
                      errors={errors}
                      onChangeValue={handleFilterCamp}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Campamento:</label>
                    <Select
                      control={control}
                      name='campamentoId'
                      data={camps}
                      disabled={camps.length === 0}
                      errors={errors}
                      onChangeValue={handleFilterLaundryPoint}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Puntos de Lavandería:</label>
                    <Select
                      control={control}
                      disabled={laundryPoint.length === 0}
                      name='puntoId'
                      data={laundryPoint}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Desde:</label>
                    <InputDate name='fechaIni' register={register} errors={errors} />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Hasta:</label>
                    <InputDate name='fechaFin' register={register} errors={errors} />
                  </div>
                </div>
                <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                  <Button label='Buscar' typeBtn='submit' disabled={searching} />
                  <Button label='Limpiar' onClick={() => handleResetForm()} />
                  {isAllowed('EXPORTAR') && (
                    <div className='position-relative' ref={refWrapperDownload}>
                      <button
                        className='sdx_btn inline-flex align-items-center gap-2'
                        type='button'
                        disabled={isDownload}
                        onClick={handleToggleOpenMenu}
                      >
                        {isDownload ? (
                          <div className='icon-container'>
                            <i className='loader'></i>
                          </div>
                        ) : (
                          <KTSVG
                            path='/media/icons/duotune/files/fil021.svg'
                            className='svg-icon-1'
                          />
                        )}
                        Descargar Reporte
                      </button>
                      <div
                        className='menu bg-white position-absolute end-0 z-index-3 border mt-1 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                        style={{display: isOpenDownloadMenu ? 'block' : 'none'}}
                      >
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('pdf')}
                          >
                            Descargar como PDF
                          </div>
                        </div>
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('xlsx')}
                          >
                            Descargar como XLSX
                          </div>
                        </div>
                        <div className='menu-item px-3'>
                          <div
                            role='button'
                            className='menu-link px-3'
                            onClick={() => handleDownloadReport('csv')}
                          >
                            Descargar como CSV
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </ButtonWrapper>
              </form>
            </FormProvider>
          </div>
        )}
        {isAllowed('LISTAR') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns} />
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryFrecuencyWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryFrecuency />
    </KTableProvider>
  )
}

export {TableLaundryFrecuencyWrapper}
